import React, { lazy } from 'react';
import { Redirect, Switch } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import PaymentPageRoutes from './PaymentPageRoutes';
import Loadable from '../ui-component/Loadable';

// project imports
import config from './../config';

// const PagesLanding = Loadable(lazy(() => import('../views/pages/landing')));

//-----------------------|| ROUTING RENDER ||-----------------------//

const Routes = () => {
    return (
        <Switch>
            {/* <Route exact path="/crm/dashboard/default" component={PagesLanding} /> */}
            <Redirect exact from="/" to={config.defaultPath} />
            <React.Fragment>
                {/* Routes for authentication pages */}
                <AuthenticationRoutes />

                {/* Route for login */}
                <LoginRoutes />

                {/* Public buyer-facing payment link page — no auth */}
                <PaymentPageRoutes />

                {/* Routes for main layouts */}
                <MainRoutes />
                {/* <Redirect exact from='*' to={config.defaultPath} /> */}
            </React.Fragment>
        </Switch>
    );
};

export default Routes;
